export const initializeTextAndPaper = () => {
    console.log("%cText Adventure", "color:#EB584D; font-size: 32px;");
    console.log("%cTo start the game run the `start()` function", "color:#F0BE58; font-size: 24px;")

    globalThis.start = (empty = "") => import("/scripts/" + "textAndPaper.js" + empty).then(textAndPaper => {
        console.clear()
        textAndPaper.start()
    })
}